
//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useContext, useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import * as moment from "moment";
import { useHistory } from "react-router-dom";

// custom pages
import { Styles } from "./styles";
import Context from "context/context";
import OverWriteApi from "apis/overwrite/overwrite";
import { toastCss, successCss } from "assets/styleJS/global";

// material-ui
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MenuItem from "@material-ui/core/MenuItem";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from 'react-i18next';
// material-ui icons
import DeleteIcon from "@material-ui/icons/Delete";
import ControlPointIcon from "@material-ui/icons/ControlPoint";
import { dateFormat } from "helpers/dataFormat"
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import useDebounce from 'helpers/useDebounce';
import PointsTransferAPI from 'apis/pointsTransfer/pointstransfer';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';




// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: "0px !important",
        marginTop: 0,
      },
      "&.MuiFormControl-marginNormal": {
        marginTop: "0px !important",
        marginBottom: "0px !important",
      },
      "& MuiSelect-outlined": {
        borderRadius: 0,
      },
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiOutlinedInput-root": {
      borderRadius: "0px !important",
      marginTop: 0,
      backgroundColor: "#fff !important",
    },
    ".MuiDialog-paperWidthSm": {
      maxWidth: "none",
      // overFlow: "hidden",
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child':
    {
      paddingLeft: 20,
    },
    ".MuiFormLabel-root": {
      color: "black",
    },
    ".MuiTable-root": {
      marginBottom: "10px",
    },
  },
})(() => null);

export default function Create(props) {
  const { state, dispatch } = useContext(Context);
  const { create, getReasonDescription, getPoints, billToSearch } =
    PointsTransferAPI();

  const { setActiveTab } = props;
  const { t, i18n } = useTranslation();
  const classes = Styles();
  const history = useHistory();

  const [data, setData] = useState([{}, {}]);

  const [billtoData, setBilltoData] = useState([]);
  const [destinationBilltoData, setDestinationBilltoData] = useState([]);


  const [open, setOpen] = useState(false);

  const [pointsTransfer, setpointsTransfer] = useState('');
  const [pointsTransferValue, setpointsTransferValue] = useState(0);
  const [pointsTransferValue1, setpointsTransferValue1] = useState(0);


  const [newDialogOpen, setNewDialogOpen] = useState(false);
  const [differentTransfer, setDifferentTransfer] = useState(false);
  const [differentTransferOption, setDifferentTransferOption] = useState(false);

  const [differentTransferData, setDifferentTransferData] = useState([]);


  const [isDisabled, setIsDisabled] = useState(false);

  // Prevent multiple Transfer API calls from rapid/multiple clicks
  const transferInProgressRef = useRef(false);

  const [reasonCode, setResaonCode] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const [billtoSearch, setBilltoSearch] = useState('');
  const [billtoSearch1, setBilltoSearch1] = useState('');

  const [billtoLoading, setBilltoLoading] = useState(false);
  const [searchType, setSearchType] = useState('');
  const [shiptoSearch, setShiptoSearch] = useState('');
  const [sourceLoyalty, setSourceLoyalty] = useState('');
  const [destinationLoyalty, setDestinationLoyalty] = useState('');
  const [selectedValueDestination, setSelectedValueDestination] = useState("");
  const [selectedValueSource, setSelectedValueSource] = useState("");

  const [offset, setOffset] = useState(1);
  const billtoSearchBounceValues = useDebounce(billtoSearch);
  const [reason, setReason] = useState([]);
  const [reasonDescription, setReasonDescription] = useState('');

  const destinationbilltoSearchBounceValues = useDebounce(billtoSearch1);



  const [shiptoLoading, setShiptoLoading] = useState(false);
  const [loyaltyLoading, setLoyaltyLoading] = useState(false);




  const [isCustomReason, setIsCustomReason] = useState(false)
  useEffect(() => {
    handleGetReasonDescriptions();
    if (searchValue && searchValue.length > 0) {
      handleGetReasonDescriptions(searchValue);
    }
    sessionStorage.removeItem("error");
  }, [searchValue]);

  useEffect(() => {
    if (billtoSearchBounceValues && billtoSearchBounceValues.length > 0) {
      handleSearch();
    }
  }, [billtoSearchBounceValues]);

  useEffect(() => {
    if (destinationbilltoSearchBounceValues && destinationbilltoSearchBounceValues.length > 0) {
      handleSearch1();
    }
  }, [destinationbilltoSearchBounceValues]);

  async function handleGetReasonDescriptions(searchValue) {
    try {
      let values = {};
      if (searchValue && searchValue.length > 0) {
        values = { ...values, searchValue };
      }
      let res = await getReasonDescription(values);
      if (res) {
        setResaonCode(res);
        console.log(res)


        setData([{
          reason_code: res[0]?.reason_description,
          reason_code_other: res[0]?.reason_description

        }]);
      }
    } catch (e) {
      console.log({ e });
    }
  }


  useEffect(() => {
    setNewDialogOpen(true);
    setData([
      {
        customer_billto_account_number: "",
        points: "",
        reason_code: "",
        rule_description: "",
        date_of_transaction: moment().format("YYYY-MM-DD")
      },
    ]);
  }, []);

  const handleCreate = async () => {

    // Important: block duplicate clicks before starting another API request
    if (transferInProgressRef.current) {
      return;
    }

    transferInProgressRef.current = true;
    setIsDisabled(true);

    try {


      let values = {
        source: selectedValueSource,
        destination: selectedValueDestination,
        pointstransfer: pointsTransfer,
        date_of_transaction: moment(new Date()).format('YYYY-MM-DD'),
        rule_description: reasonDescription,
        reason_code: data[0]?.reason_code,
        sourceloyalty: sourceLoyalty,
        destinationloyalty: destinationLoyalty,
        pointstransferdestination: parseInt(pointsTransferValue)
      };

      let res = await create(values);

      if (res && res.type === "success") {
        setData([]);
        history.push("/dashboard/upload-success", {
          type: i18n.language == 'fr' ? res.french_message : res.message,
        });
      }

      else if (res && res.type === "Pending") {
        setDifferentTransfer(true)
        setDifferentTransferData(res.data)
        setpointsTransferValue1(pointsTransferValue)

      }

      else {
        toast.error(i18n.language == 'fr' ? res?.french_message : res.message, toastCss);
      }

    } catch (e) {
      console.log("errors");
    } finally {
      // Re-enable Transfer only after the API has completed
      transferInProgressRef.current = false;
      setIsDisabled(false);
    }
  };


  // points format func
  const pointFormat = (point) => {
    var nfObject = new Intl.NumberFormat("en-US");
    var res = nfObject.format(point);
    return res;
  };

  const headings = [
    "Source Billto",
    "Destination Billto",
    "Source Points",
    "Transfer Points",
    "Reason Code",
    "Customer facing Description",
  ];

  const handleSearch = async () => {
    try {
      let values;



      values = {
        searchValue: billtoSearch,
        searchType: searchType,
      };

      let res = await billToSearch(values);
      if (res) {
        setBilltoData(res.data);
      }
      setShiptoLoading(false);
      setLoyaltyLoading(false);
      setBilltoLoading(false);
    } catch (e) {
      console.log('errors');
    }
  };

  const handleSearch1 = async () => {
    try {
      let values;



      values = {
        searchValue: billtoSearch1,
        searchType: searchType,
      };

      let res = await billToSearch(values);
      if (res) {
        setDestinationBilltoData(res.data);
      }
      setShiptoLoading(false);
      setLoyaltyLoading(false);
      setBilltoLoading(false);
    } catch (e) {
      console.log('errors');
    }
  };

  const handleGetPoints = async (loyaltyID) => {
    try {

      let values = loyaltyID;


      let res = await getPoints(values);

      if (res) {
        setpointsTransfer(res.availableToRedeem)

      }

    } catch (e) {
      console.log('errors');
    }
  };

  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

  const blockPointsInvalidChar = (e) =>
    ["e", "E", "+"].includes(e.key) && e.preventDefault();

  return (
    <React.Fragment>
      <GlobalCss />
      <Dialog
        onClose={() => {
          setNewDialogOpen(!newDialogOpen);
        }}
        aria-labelledby="simple-dialog-title"
        open={newDialogOpen}
        maxWidth='md'
      >
        <div style={{ padding: "50px 20px" }}>
          <Grid container spacing={0}>
            <span
              style={{
                position: "absolute",
                right: "2%",
                top: "1%",
                cursor: "pointer",
                fontSize: 20,
              }}
              onClick={() => setActiveTab(0)}
            >
              x
            </span>
            <Grid item xs={12} style={{ textAlign: "center", fontSize: 20 }}>
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {t('Insert Data for Points Transfer')}
              </span>
            </Grid>
            <Grid item xs={12} className={classes.gridFive}>
              <span className={classes.gridThreeSpan}>{t('Generated Date')} : </span>
              <span>{dateFormat(moment(new Date()).format("MM-DD-YYYY"), i18n.language)}</span>
            </Grid>
            <Grid xs={12}>
              <TableContainer className={classes.tableContainer}>
                <Table>
                  <TableHead
                    style={{
                      background: "#EDEDED",
                    }}
                  >
                    <TableRow>
                      {headings.map((h, i) => (
                        <TableCell
                          key={i}
                          style={{
                            color: "#000",
                            fontWeight: "bold",
                            fontSize: 16,
                            fontFamily: "segoe-ui !important",
                            padding: 0,
                            border: "1px solid",
                            textAlign: "center",
                            width: 300,
                          }}
                        >
                          {t(h)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((item, index) => {
                      return (
                        <TableRow role="checkbox" tabIndex={-1} key={0}>
                          <TableCell align="left" className={classes.rowCell}>
                            <Autocomplete
                              id='billto-search'
                              // key={shiptoSearch}
                              options={billtoData}
                              getOptionLabel={(o) => o.customer_billto_account_number}
                              filterOptions={(options, state) => options}
                              inputValue={billtoSearch}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant='outlined'
                                  type='number'
                         onWheel={(e) => e.target.blur()}
                                  onKeyDown={blockInvalidChar}
                                  value={billtoSearch}
                                  placeholder={t('Search by Billto ID')}
                                  onChange={(e) => {

                                    setBilltoSearch(e.target.value);
                                  }}
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <React.Fragment>
                                        {billtoLoading ? (
                                          <CircularProgress color='inherit' size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </React.Fragment>
                                    ),
                                  }}
                                  onClick={() => {


                                    setSearchType('source_billto');

                                    // document.getElementById("shipto-search").value = "";
                                  }}
                                />
                              )}
                              onChange={(value, a, reason) => {
                                if (reason === 'clear') {
                                  setBilltoSearch('');
                                  return;
                                }

                                if (a) {
                                  setSelectedValueSource(a.customer_billto_account_number);
                                  setBilltoSearch(a.customer_billto_account_number);
                                  setSourceLoyalty(a?.loyalty_id)
                                  handleGetPoints(a.loyalty_id)
                                  setOffset(1);
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell align="left" className={classes.rowCell}>
                            <Autocomplete
                              id='billto-search'
                              // key={shiptoSearch}
                              options={destinationBilltoData}
                              getOptionLabel={(o) => o.customer_billto_account_number}
                              filterOptions={(options, state) => options}
                              inputValue={billtoSearch1}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant='outlined'
                                  type='number'
                         onWheel={(e) => e.target.blur()}
                                  onKeyDown={blockInvalidChar}
                                  value={billtoSearch1}
                                  placeholder={t('Search by Billto ID')}
                                  onChange={(e) => {

                                    setBilltoSearch1(e.target.value);
                                  }}
                                  InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <React.Fragment>
                                        {billtoLoading ? (
                                          <CircularProgress color='inherit' size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                      </React.Fragment>
                                    ),
                                  }}
                                  onClick={() => {
                                    setSearchType('destination_billto');

                                    // document.getElementById("shipto-search").value = "";
                                  }}
                                />
                              )}
                              onChange={(value, a, reason) => {
                                if (reason === 'clear') {
                                  setBilltoSearch1('');
                                  return;
                                }
                                if (a) {
                                  setSelectedValueDestination(a.customer_billto_account_number);
                                  setBilltoSearch1(a.customer_billto_account_number);
                                  setDestinationLoyalty(a?.loyalty_id)
                                  setOffset(1);
                                }
                              }}
                            />
                          </TableCell>
                          <TableCell align="left" className={classes.rowCell}>
                            <CssTextField
                              type={"text"}
                              variant="outlined"
                              className={classes.extendedInput}
                              value={pointFormat(pointsTransfer ? pointsTransfer : 0)}
                              InputProps={{
                                readOnly: true,
                              }}

                              // onKeyDown={blockPointsInvalidChar}
                              // onChange={(e) => {
                              // let arr = [...data];
                              // let value = e.target.value;
                              // if (e.target.value === "") {
                              //   arr[index].points = "";
                              //   setData(arr);
                              //   return;
                              // }
                              // value = value.replace(/\,/g, "");
                              // if (value !== "-") {
                              //   arr[index].points = pointFormat(
                              //     parseInt(value)
                              //   );
                              // } else {
                              //   arr[index].points = "-";
                              // }
                              // setData(arr);
                              // }}

                            />
                          </TableCell>
                          <TableCell align="left" className={classes.rowCell}>
                            <CssTextField
                              type={"text"}
                              variant="outlined"
                              className={classes.extendedInput}
                              value={pointFormat(pointsTransferValue)}
                              InputProps={{
                                readOnly: false,
                              }}

                              onKeyDown={blockPointsInvalidChar}
                              onChange={(e) => {

                                let value = e.target.value;
                                if (e.target.value === "") {
                                  setpointsTransferValue(0)

                                  return;
                                }
                                value = value.replace(/\,/g, "");
                                console.log(value, pointsTransfer, "this is the values")
                                if (value !== "-") {

                                  // if(value <= pointsTransfer){
                                  setpointsTransferValue(value)
                                  // }

                                } else {
                                  setpointsTransferValue(0)
                                }

                              }}
                            />
                          </TableCell>
                          <TableCell align="left" className={classes.rowCell}>
                            {data[index]?.reason_code_other === "Others" ? (
                              <CssTextField
                                id="combo-box-demo"
                                type={"text"}
                                placeholder={t("Enter a reason")}
                                variant="outlined"
                                autoComplete="off"
                                //  className={classes.extendedInput}
                                value={data[index]?.reason_code}
                                onChange={(e) => {
                                  let arr = [...data];
                                  arr[index].reason_code = e.target.value;
                                  setData(arr);
                                }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">

                                      <IconButton
                                        onClick={() => {
                                          let arr = [...data];
                                          arr[index].reason_code = "";
                                          arr[index].reason_code_other = "";
                                          setData(arr);
                                        }}
                                      >
                                        <ClearIcon />
                                      </IconButton>

                                    </InputAdornment>
                                  ),
                                }}
                              />
                            ) :
                              <Autocomplete
                                id="combo-box-demo"
                                autoSelect={true}
                                options={reasonCode}
                                inputValue={data[index].reason_code}
                                value={data[index].reason_code}
                                getOptionLabel={(o) => t(o.reason_description)}
                                filterOptions={(options, state) => options}
                                renderInput={(params) => (
                                  <CssTextField
                                    {...params}
                                    variant="outlined"
                                    value={searchValue}
                                    onChange={(e) => {
                                      setSearchValue(e.target.value);
                                    }}
                                  />
                                )}
                                onChange={(value, a, reason) => {
                                  if (reason === "clear") {
                                    let arr = [...data];
                                    arr[index].reason_code = "";
                                    arr[index].reason_code_other = "";

                                    setData(arr);
                                    setIsCustomReason(false)

                                    return;
                                  }

                                  if (a?.reason_description === "Others") {
                                    // setIsCustomReason(true)
                                    let arr = [...data];
                                    arr[index].reason_code = "";
                                    arr[index].reason_code_other = a?.reason_description
                                    setData(arr);
                                    return;
                                  }

                                  let arr = [...data];
                                  arr[index].reason_code = a?.reason_description;
                                  arr[index].reason_code_other = a?.reason_description;

                                  setData(arr);
                                }}
                              />
                            }

                          </TableCell>
                          <TableCell align="left" className={classes.rowCell}>
                            <CssTextField
                              type={"text"}
                              variant="outlined"
                              className={classes.extendedInput}
                              value={reasonDescription}
                              onChange={(e) => {

                                setReasonDescription(e.target.value)
                              }}
                            />
                          </TableCell>

                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  className={classes.popupCancelBtn}
                  onClick={() => setActiveTab(0)}
                >
                  {t('Cancel')}
                </button>
                <button
                  disabled={isDisabled}
                  className={classes.saveBtn}
                  onClick={() => {

                    if (!billtoSearch || !selectedValueSource) {
                      toast.error("Please select a valid  Source Bill To", {
                        ...toastCss,
                        autoClose: 5000,
                      });
                      return;
                    }

                    if (!billtoSearch1 || !selectedValueDestination) {
                      toast.error("Please select a valid Destination Bill To", {
                        ...toastCss,
                        autoClose: 5000,
                      });
                      return;
                    }

                    if (!billtoSearch || !billtoSearch1 || !reasonDescription || !data[0].reason_code) {
                      toast.error("Please fill in all the fields.", {
                        ...toastCss,
                        autoClose: 5000,
                      });
                      return;
                    }

                    if (pointsTransfer <= 0) {
                      toast.error("Please select an account with more than 0 points.", {
                        ...toastCss,
                        autoClose: 5000,
                      });
                      return;
                    }

                    if (pointsTransferValue <= 0) {
                      toast.error("Transfer points must be greater than zero.", {
                        ...toastCss,
                        autoClose: 5000,
                      });
                      return;
                    }

                    if (pointsTransfer < pointsTransferValue) {
                      toast.error("Transfer amount cannot exceed available points in the source account.", {
                        ...toastCss,
                        autoClose: 5000,
                      });
                      return;
                    }

                    if (selectedValueDestination == selectedValueSource) {
                      toast.error("The source and destination Bill To cannot be the same.", {
                        ...toastCss,
                        autoClose: 5000,
                      });
                      return;
                    }

                    if (reasonDescription.length > 120) {
                      toast.error("Customer Facing Description must be 120 characters or fewer.", {
                        ...toastCss,
                        autoClose: 5000,
                      });
                      return;
                    }


                    // setData(array);
                    handleCreate();

                  }}
                >
                  {t('Transfer')}
                </button>
                <button
                  className={classes.saveBtn}
                  style={{ position: "absolute", right: "5%" }}
                  onClick={() => {
                    setBilltoSearch1('')
                    setBilltoSearch('')
                    setReason('')
                    setReasonDescription('')
                    setpointsTransfer('')
                    setpointsTransferValue('')
                    // setData([{
                    //   customer_billto_account_number: "",
                    //   points: "",
                    //   reason_code: "",
                    //   rule_description: "",
                    //   date_of_transaction: moment().format("YYYY-MM-DD")
                    // }])
                  }}
                >
                  {t('Reset')}
                </button>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Dialog>
      <Dialog
        aria-labelledby='simple-dialog-title'
        open={differentTransfer}
        style={{ fontFamily: 'Segoe-ui' }}
      >
        <div className={classes.dialogParentDiv}>
          <div className={classes.parentText}>
            {' '}
            {t('Select Points to Transfer')}
          </div>

          <br />
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue=""
            name="radio-buttons-group"
            value={pointsTransferValue}
            onChange={(e) => {
              setDifferentTransferOption(true)
              setpointsTransferValue(e?.target?.value);
            }}
          >
            {differentTransferData.map((option, index) => (
              <FormControlLabel
                key={index}
                value={String(option.cumulative_sum)} // force string
                control={<Radio color="primary" />}
                label={`Transfer ${option.cumulative_sum} Points`} // optional label
              />
            ))}
          </RadioGroup>
          <Grid container spacing={0}>
            {/* <Grid item xs={6}> */}
            <button
              className={classes.popupCancelBtn}
              onClick={() => {
                setDifferentTransfer(false);
                setpointsTransferValue(pointsTransferValue1)
              }}
            >
              {t('Cancel')}
            </button>
            {/* </Grid> */}
            {/* <Grid item xs={6} className={classes.proceedBtnGrid}> */}

            <button
              disabled={isDisabled}
              className={classes.popupCancelBtn1}
              onClick={() => {
                if (!differentTransferOption) {
                  toast.error("Please select a points option before proceeding.", {
                    ...toastCss,
                    autoClose: 5000,
                  });
                  return;
                }

                handleCreate();

              }}
            >
              {t('Transfer')}
            </button>
            {/* </Grid> */}
          </Grid>
        </div>
      </Dialog>
    </React.Fragment>
  );
}

